export default __webpack_public_path__ + "static/media/blueSearchIcon.286f803e.svg";